module.exports = __webpack_public_path__ + "img/site-development.d7f91ea9.svg";